import type { FC } from "react";
import { Outlet } from "react-router-dom";

const SDKRootRoute: FC = () => {
  return <Outlet />;
};

export default SDKRootRoute;
